const baseURL = 'https://api.sampleapis.com/wines';

export default baseURL;
